import { render } from "./BaseProductTile.vue?vue&type=template&id=6656f9c2&scoped=true"
import script from "./BaseProductTile.vue?vue&type=script&lang=js"
export * from "./BaseProductTile.vue?vue&type=script&lang=js"

import "./BaseProductTile.vue?vue&type=style&index=0&id=6656f9c2&lang=scss&scoped=true"
import "./BaseProductTile.vue?vue&type=style&index=1&id=6656f9c2&lang=scss"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6656f9c2"]])

export default __exports__